"use client"

import { Cog } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CogIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CogIcon = component(Icon)({ as: Cog })
